import React from "react";
import Sidebar from "./Sidebar";

function RootLayout({ children }) {
  return (
    <div className="flex h-screen bg-gray-50 font-Montserrat overflow-hidden">
      <Sidebar />
      <main className="flex-1 overflow-y-auto">
        {/* Top padding on mobile for the hamburger button */}
        <div className="md:hidden h-14" />
        <div className="p-6 md:p-8">{children}</div>
      </main>
    </div>
  );
}

export default RootLayout;
